import { observer } from "mobx-react";
import React, { useEffect } from 'react'
import { Button } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import { useStores } from "../../../../hooks";
import { Helmet } from "react-helmet";
import NoModifiersSets from "./components/NoModifiersSets";
import { FadeInOutVertical } from "../../../../common/components/Animated";
import { Centered, FlexRowSpaceBetween, FlexRowStart, Paper, Typography } from "../../../../common/components/libs";
import { useHistory } from "react-router-dom";
import { localize, toLocalizedString } from "../../../../common/libs";
import { Delete as RemoveIcon } from "@material-ui/icons";
import { FileCopyOutlined as CopyIcon } from '@material-ui/icons';
import {
    MenuItemModifierSet,
    MenuItemModifierSetChooseManyData,
    MenuItemModifierSetChooseOneData,
    ModifiersSetType
} from "../../../../services/menu/models";
import {  useTranslation } from "react-i18next";
import { generateClientSyncId } from "../../../../apiCommandsExecutor";
import { ModifiersFormType } from "../../store/modifiersSets/forms";


const HeaderButton = () => {
    const { t } = useTranslation(["general", "menu"]);
    const { modifiersSetsStore } = useStores();
    return <Button variant="contained" color="primary"
                   onClick={() => modifiersSetsStore.forms.showPopupForm(ModifiersFormType.editMenuModifiersSet)}>
        <AddIcon/>
        {t("general:add")}
    </Button>
};

const ModifiersSet = () => {
    const { t, ready } = useTranslation(["general", "menu"], { useSuspense: false });
    const { generalStore, modifiersSetsStore } = useStores();
    const history = useHistory();

    useEffect(() => {
        generalStore.setPageTitle(t("menu:modifiersSet.modifiersSets"), <HeaderButton/>);

        modifiersSetsStore.loadModifiersSet();
    }, [generalStore, modifiersSetsStore, ready]);


    const openDeleteForm = (item?: MenuItemModifierSet) => {
        modifiersSetsStore.forms.showPopupForm(ModifiersFormType.deleteMenuModifiersSet, item);
    }
    const navigateToModifiersSetPage = async (item?: MenuItemModifierSet) => {
        history.push(`/menus/modifiers/${item.id}/view`)
    };


    const items = modifiersSetsStore.modifiersSets;

    if (!items) return;
    return <>
        <Helmet title={t("menu:modifiersSet.modifiersSets")}/>
        {
            items.length === 0 &&
			<FadeInOutVertical show={true}>
				<Centered>
					<NoModifiersSets/>
				</Centered>
			</FadeInOutVertical>
        }
        {
            items.length > 0 && <FadeInOutVertical show={true}>
				<>
                    {
                        items.map(item => {
                            return <Paper p={5} mb={5} key={item.id} onClick={() => {
                                history.push(`/menus/modifiers/${item.id}/view`)
                            }}>
                                <FlexRowSpaceBetween>
                                    <Typography variant={"h5"}>
                                        {localize(item.data.name)}
                                    </Typography>
                                    <div style={{ textAlign: "right", marginLeft: "10px" }}>
                                        <Button color="default"
                                                style={{ paddingLeft: "0", marginTop: -5, marginRight: 15 }}
                                                onClick={(e: React.MouseEvent) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    openDeleteForm(item);
                                                }}>
                                            <RemoveIcon color="error"/>
                                            <span
                                                style={{ display: "inline-block", minWidth: 5 }}
                                            />
                                            {t("general:delete")}
                                        </Button>
                                        <Button
                                            style={{ padding: 0, marginTop: -5, marginRight: 15 }}
                                            color="primary"
                                            onClick={async (e: React.MouseEvent) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                let data;
                                                const newName = toLocalizedString(localize(item.data.name) + "(1)");
                                                if (item.data.type === ModifiersSetType.ChooseMany) {
                                                    data = {
                                                        name: newName,
                                                        modifiers: item.data.modifiers.map(item => ({
                                                            ...item,
                                                            id: generateClientSyncId()
                                                        })),
                                                        type: item.data.type,
                                                        minCountTotalChosen: item.data.minCountTotalChosen,
                                                        maxCountTotalChosen: item.data.maxCountTotalChosen,
                                                    } as MenuItemModifierSetChooseManyData;
                                                } else if (item.data.type === ModifiersSetType.ChooseOne) {
                                                    data = {

                                                        name: newName,
                                                        modifiers: item.data.modifiers.map(item => ({
                                                            ...item,
                                                            id: generateClientSyncId()
                                                        })),
                                                        type: item.data.type,
                                                        isRequired: item.data.isRequired,
                                                    } as MenuItemModifierSetChooseOneData;
                                                }
                                                const id = await modifiersSetsStore.createModifiersSet({ data });
                                                generalStore.showSuccessSnackbar("Набор модификаторов скопирован");
                                                const newItem = modifiersSetsStore.getModifiersSetById(id);
                                                navigateToModifiersSetPage(newItem);
                                            }
                                            }>
                                            <CopyIcon fontSize='small'/>
                                            <span
                                                style={{ display: "inline-block", minWidth: 5 }}
                                            />
                                            {t("general:copy")}
                                        </Button>
                                    </div>

                                </FlexRowSpaceBetween>
                                <FlexRowStart>
                                    <div>

                                        <Typography variant='body1' mt={1}>
                                            {t("menu:modifiersSet.type")} {t(`menu:modifiersSetType.${item.data.type}`)}
                                        </Typography>
                                        <Typography variant='body1' mt={1}>
                                            {t("menu:modifiersSet.countModifiersSets")} {item.data.modifiers.length}
                                        </Typography>

                                    </div>
                                </FlexRowStart>
                            </Paper>
                        })}
				</>
			</FadeInOutVertical>
        }
    </>
};

export default observer(ModifiersSet)
